
export const reviews = [
  {
    id: 1,
    name: 'Олександр Коваленко',
    service: 'Заміна лобового скла',
    text: 'Звернувся для заміни лобового скла на Toyota Camry. Роботу виконали швидко та якісно. Майстри професійні, все пояснили та показали. Скло встановили ідеально, жодних нарікань. Ціна адекватна. Рекомендую!',
    rating: 5
  },
  {
    id: 2,
    name: 'Марина Петренко',
    service: 'Тонування',
    text: 'Робила тонування бокових стекол. Дуже задоволена результатом! Плівка наклеєна акуратно, без жодних бульбашок. Майстер порадив оптимальний рівень затемнення. Салон тепер не так нагрівається на сонці. Дякую за якісну роботу!',
    rating: 5
  },
  {
    id: 3,
    name: 'Ігор Мельник',
    service: 'Ремонт сколу',
    text: 'Після зими з\'явився скол на лобовому склі. Звернувся сюди за порадою знайомих. Відремонтували за 40 хвилин, скол майже непомітний. Ціна приємно здивувала. Набагато дешевше, ніж міняти все скло. Рекомендую не зволікати з ремонтом!',
    rating: 5
  },
  {
    id: 4,
    name: 'Наталія Сидоренко',
    service: 'Заміна бокового скла',
    text: 'Розбили бокове скло на парковці. Зателефонувала, скло було в наявності. Приїхала, за 30 хвилин все замінили. Склопідйомник працює ідеально. Дуже вдячна за оперативність та професіоналізм!',
    rating: 5
  },
  {
    id: 5,
    name: 'Дмитро Бондаренко',
    service: 'Заміна лобового скла',
    text: 'Міняв лобове скло на Volkswagen Passat. Все зробили на найвищому рівні. Скло оригінальне, встановлено якісно. Майстри пояснили всі нюанси догляду після заміни. Через тиждень перевірив – все герметично, жодних проблем. Дякую!',
    rating: 5
  },
  {
    id: 6,
    name: 'Світлана Ткаченко',
    service: 'Заміна заднього скла',
    text: 'Потрібно було замінити заднє скло з підігрівом на Honda CR-V. Переживала, що можуть виникнути проблеми з підключенням підігріву. Але майстри все зробили професійно, підігрів працює відмінно. Рекомендую цей сервіс!',
    rating: 5
  },
  {
    id: 7,
    name: 'Андрій Шевченко',
    service: 'Автоскло для вантажівок',
    text: 'Замовляв заміну лобового скла на Mercedes Sprinter. Приємно здивувала оперативність – скло привезли наступного дня. Встановили швидко та якісно. Ціна нижча, ніж в інших місцях. Буду звертатися ще!',
    rating: 5
  },
  {
    id: 8,
    name: 'Юлія Кравченко',
    service: 'Тонування',
    text: 'Тонувала скла на новому автомобілі. Майстер дуже уважний до деталей, все зробив акуратно. Плівка якісна, виглядає дуже естетично. Ціна адекватна якості. Задоволена на всі 100%!',
    rating: 5
  }
];
